/**
 * @file AppRoutes.js
 * @feature Routing
 * @description Renders the full route tree from routes.config.js.
 *
 * KEY CONCEPTS:
 * 1. Suspense wraps the outlet directly — no nested <Routes> inside path="*"
 *    The previous nested <Routes> inside a path="*" was eating the initial
 *    render of / and /dashboard until a manual click triggered re-evaluation.
 *
 * 2. Home is eagerly imported in routes.config.js so it renders instantly
 *    on / and /dashboard without waiting for any chunk download.
 *
 * 3. LOG_RENDER — set to false before production build.
 */

import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PageLayout } from '../../../components/common/PageLayout';
import NotFound from '../../../components/Login/NotFound';
import { APP_ROUTES } from './routes.config';
import Loader from '../../../components/Loader';
import { ErrorBoundary } from '../../../components/ErrorBoundary';


const LOG_RENDER = true;

const RouteWithLog = ({ component: Component, name, path }) => {
  if (LOG_RENDER) {
  }
  return <Component />;
};

const PageLoader = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: '14px', color: '#888' }}>
    <Loader/>
  </div>
);

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<PageLayout />}>

      {/* Redirect bare / → /dashboard so sidebar active-link is always correct */}
      <Route index element={<Navigate to="/dashboard" replace />} />

      {/* All app routes — Suspense handles lazy chunk downloads */}
      <Route
        path="*"
        element={
          // <ErrorBoundary title="Page failed to load">
            <Suspense fallback={<PageLoader />}>
              <Routes>
                {APP_ROUTES.map(({ path, component, name }) => (
                  <Route
                    key={path}
                    path={path}
                    element={<RouteWithLog component={component} name={name} path={path} />}
                  />
                ))}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          // </ErrorBoundary>
        }
      />

    </Route>
  </Routes>
);

export default AppRoutes;


// /**
//  * @file AppRoutes.jsx
//  * @feature Routing
//  * @description Renders the full route tree from routes.config.js.
//  * App.jsx never imports individual page components — they all live here.
//  *
//  * To add or remove a route: edit routes.config.js only.
//  */

// import React from 'react';
// import { Routes, Route } from 'react-router-dom';
// import { PageLayout } from '../../../components/common/PageLayout';
// import NotFound from '../../../components/Login/NotFound';
// import { APP_ROUTES } from './routes.config';

// const AppRoutes = () => (
//   <Routes>
//     <Route path="/" element={<PageLayout />}>
//       {APP_ROUTES.map(({ path, component: Component }) => (
//         <Route key={path} path={path} element={<Component />} />
//       ))}
//       {/* Catch-all — must be last */}
//       <Route path="*" element={<NotFound />} />
//     </Route>
//   </Routes>
// );

// export default AppRoutes;